import { render, staticRenderFns } from "./MtrlAddMain.vue?vue&type=template&id=45d6b7ab&scoped=true&"
import script from "./MtrlAddMain.vue?vue&type=script&lang=js&"
export * from "./MtrlAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrlAddMain.vue?vue&type=style&index=0&id=45d6b7ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d6b7ab",
  null
  
)

export default component.exports